var _style, _path, _path2, _path3, _path4, _path5, _path6, _g, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg04(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Isolation_Mode",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "262.7px",
    height: "106.5px",
    viewBox: "0 0 262.7 106.5",
    style: {
      enableBackground: "new 0 0 262.7 106.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#0B8CD3;}\n\t.st1{fill:url(#SVGID_1_);}\n\t.st2{fill:#0071BC;}\n\t.st3{fill:url(#SVGID_2_);}\n\t.st4{fill:url(#SVGID_3_);}\n\t.st5{fill:url(#SVGID_4_);}\n\t.st6{fill:#FFFFFF;}\n\t.st7{fill-rule:evenodd;clip-rule:evenodd;fill:url(#voyage_1_);}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M32.8,70.7c-2.3,1.6-4.8,2.7-7.5,3.4l-2.7,0.7c-0.2,0-0.3,0.1-0.5,0.1c-0.8,0-1.5-0.4-1.9-1.2 c-0.5-0.9-0.2-2,0.5-2.6l14.9-12.5c-2.3,0.8-4.5,1.5-6.6,2.2c-3.8,1.3-7.3,2.4-10.2,3.4c-1.6,1.9-2.5,4.6-1.2,8.5l0.9,1.9 c0,0,12.9,26.3,13.4,27.2c1.7,2.9,4.9,4.9,8.5,4.9c4,0,7.4-2.4,9-5.7c0.3-0.6,22.3-44.9,22.3-44.9l0,0l1.9-3.8 c1-2.2,1.7-4.6,2.2-7.1c-4,1.3-7.9,2.7-11.8,4L32.8,70.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 45.9607,
    y1: 88.2977,
    x2: 86.4407,
    y2: 34.9647
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0B8CD3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0051BC"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M28.3,94.2c2,4,3.5,7.1,3.7,7.4c1.7,2.9,4.9,4.9,8.5,4.9c4,0,7.4-2.4,9-5.7c0.3-0.6,22.3-44.9,22.3-44.9l0,0 l1.9-3.8c1-2.2,1.7-4.6,2.2-7.1c-3,1-6.1,2-9,3.1C63.4,56.6,51.7,81.6,28.3,94.2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M40.5,1.5c-20,0-36.1,16.2-36.1,36.1c0,4.5,0.8,8.9,2.4,12.8c0.6,1.5,3,5.5,9.7,5l6.3-2.7 c-1.1-2.4-1.6-5-1.6-7.8c0-10.7,8.7-19.4,19.4-19.4c8,0,14.9,4.8,17.8,11.7l17.4-7.6C72.1,13.6,57.7,1.5,40.5,1.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 64.8972,
    y1: 28.8546,
    x2: 68.3937,
    y2: 35.6997
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0071BC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0051BC"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M58.3,37.3l17.4-7.6c-0.5-2.2-1.2-4.2-2-6.2c-5.9,2.7-12.3,5.6-18.8,8.6C56.3,33.6,57.5,35.4,58.3,37.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 43.0107,
    y1: 23.7148,
    x2: 56.569,
    y2: 0.472
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0071BC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0051BC"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M40.5,1.5c-20,0-36.1,16.2-36.1,36.1c0,2.2,0.2,4.3,0.6,6.4C4.6,38.4,13.5,8.4,42,10.6 c12.8,1,22.7,10.1,24.6,22.6l9.2-3.5C72.1,13.6,57.7,1.5,40.5,1.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 17.4999,
    y1: 54.1422,
    x2: 21.9321,
    y2: 60.7165
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0071BC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0051BC"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M16.4,55.6l6.3-2.7c-0.7-1.7-1.3-3.5-1.5-5.4c-4.9,2.2-9.3,4.2-12.7,5.7C10,54.5,12.4,55.8,16.4,55.6z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M24.7,71.6c2.4-0.6,4.6-1.6,6.6-3l24.2-16.9c-4.7,1.6-9.2,3.1-13.4,4.5L23.5,71.9L24.7,71.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M44.9,53.9l-5.3,4.4c3.9-1.3,8.1-2.7,12.5-4.2l7.4-5.1C54.5,50.7,49.5,52.3,44.9,53.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M143.1,17.4c-1.3-2.1-4.4-3.4-8.3-4.1c-0.5-0.1-1-0.2-1.5-0.2c-5.5-0.7-12.5-0.5-18.5,0 c-3.2,0.3-6.3,1-9.2,2.3l-92,40.1c2.3,0.3,5.4,0.1,9.5-1.4l83.5-36.4c2.7-1.2,5.5-1.9,8.4-2.1c4.8-0.4,9-0.5,12.6-0.4 l-16.2,5.9c-0.8,0.3-1.2,1.1-0.9,1.9c0.2,0.6,0.8,1,1.4,1c0.2,0,0.3,0,0.5-0.1l22-8c0.1,0,0.1-0.1,0.2-0.1 c3.4,0.6,5.6,1.5,6.4,2.8c0,0.2-0.3,1-2.5,2.7c-1.4,1.2-3.1,2.1-4.9,2.7c-7.9,2.7-37.6,12.7-65.5,22.1l-7.4,5.1 c30-10.1,65-21.9,73.7-24.8c2.1-0.7,4-1.7,5.6-3.1c1-0.8,3.5-2.8,3.5-4.8C143.4,18.2,143.3,17.8,143.1,17.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M17.7,65.7c3.2-1.1,8.6-2.9,15.5-5.2l5.3-4.4c-6.6,2.2-12.3,4.1-16.5,5.6C20.3,62.5,18.6,63.8,17.7,65.7z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M23.5,71.9l1.2-0.3c2.4-0.6,4.6-1.6,6.6-3l43-29.9c0.4-0.2,0.1-0.8-0.3-0.6L54.5,46 c-0.2,0.1-0.4,0.2-0.5,0.3L23.5,71.9z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "voyage_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 78.4733,
    y1: 80.0987,
    x2: 262.6939,
    y2: 80.0987
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#279CFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "voyage",
    className: "st7",
    d: "M87.3,60.3h-8.8L88,87.1h10.1l9.5-26.8h-8.7l-5.8,19.1L87.3,60.3z M123.3,87.5 c2.5,0,4.9-0.5,7.1-1.7c2.1-1.1,3.9-2.8,5-4.8c1.3-2.2,1.9-4.7,1.9-7.3c0.1-2.5-0.6-5.1-1.8-7.3c-1.2-2.1-2.9-3.7-5-4.8 c-4.5-2.2-9.8-2.2-14.2,0c-2.1,1.1-3.8,2.8-5,4.8c-1.3,2.2-1.9,4.7-1.8,7.3c-0.1,2.6,0.6,5.1,1.8,7.3c1.2,2,2.9,3.7,5,4.8 C118.4,86.9,120.9,87.5,123.3,87.5L123.3,87.5L123.3,87.5z M123.3,80.4c-1.5,0-2.9-0.6-3.9-1.7c-1.1-1.4-1.7-3.2-1.6-4.9 c-0.1-1.8,0.4-3.6,1.6-5c1-1.1,2.5-1.7,4-1.7c1.5,0,3,0.6,4,1.7c1.2,1.4,1.7,3.1,1.6,4.9c0.1,1.8-0.5,3.6-1.7,4.9 C126.3,79.8,124.8,80.4,123.3,80.4L123.3,80.4z M160.2,60.3l-6.2,16.8l-6.2-16.8h-9.2l10.9,25.9l-6.2,13.6h8.8l16.8-39.5H160.2 L160.2,60.3z M170.5,73.6c-0.1,2.5,0.5,5,1.6,7.3c0.9,2,2.4,3.7,4.3,4.8c1.8,1.1,3.9,1.7,6,1.7c1.7,0,3.4-0.4,5-1.2 c1.4-0.7,2.5-1.7,3.3-3v3.8h8.2V60.3h-8.2v3.8c-0.8-1.3-1.9-2.3-3.3-3c-1.5-0.8-3.2-1.2-5-1.2c-2.1,0-4.2,0.6-6,1.7 c-1.8,1.2-3.3,2.8-4.3,4.8C171,68.7,170.4,71.1,170.5,73.6L170.5,73.6z M190.6,73.7c0.1,1.8-0.5,3.5-1.7,4.8 c-2.2,2.3-5.8,2.4-8.1,0.2c-0.1-0.1-0.1-0.1-0.2-0.2c-1.2-1.3-1.8-3.1-1.7-4.9c-0.1-1.8,0.5-3.5,1.7-4.8c2.2-2.3,5.9-2.3,8.2-0.1 c0,0,0.1,0.1,0.1,0.1C190.1,70.2,190.7,71.9,190.6,73.7L190.6,73.7z M215,59.9c-2.1,0-4.2,0.6-6,1.7c-1.8,1.2-3.3,2.8-4.3,4.8 c-2.1,4.6-2.1,9.9,0,14.5c0.9,2,2.4,3.7,4.3,4.8c1.8,1.1,3.9,1.7,6,1.7c1.7,0,3.4-0.4,5-1.2c1.3-0.7,2.5-1.8,3.3-3.1V87 c0,2.2-0.5,3.7-1.5,4.7c-1.1,1-2.6,1.5-4.1,1.5c-1.2,0-2.5-0.3-3.6-0.9c-0.9-0.5-1.6-1.4-1.8-2.4h-8.1c0.3,3,1.8,5.8,4.2,7.6 c2.5,1.9,5.7,2.8,9.7,2.8c2.6,0.1,5.2-0.5,7.5-1.8c1.9-1.1,3.5-2.8,4.5-4.8c1-2.1,1.5-4.4,1.5-6.7V60.3h-8.2v3.8 c-0.8-1.3-1.9-2.3-3.3-3C218.4,60.3,216.7,59.9,215,59.9L215,59.9z M223.2,73.7c0.1,1.8-0.5,3.5-1.7,4.8 c-2.2,2.3-5.8,2.4-8.1,0.2c-0.1-0.1-0.1-0.1-0.2-0.2c-1.2-1.3-1.8-3.1-1.7-4.9c-0.1-1.8,0.5-3.5,1.7-4.8c2.2-2.3,5.9-2.3,8.2-0.1 c0,0,0.1,0.1,0.1,0.1C222.7,70.2,223.3,71.9,223.2,73.7L223.2,73.7z M262.7,73.3c0.1-2.5-0.5-4.9-1.7-7.1c-1.1-2-2.7-3.6-4.7-4.7 c-4.4-2.2-9.6-2.2-14,0c-2,1.1-3.7,2.8-4.8,4.8c-1.2,2.2-1.8,4.8-1.7,7.3c-0.1,2.5,0.5,5.1,1.7,7.3c1.1,2,2.8,3.7,4.8,4.8 c2.2,1.1,4.6,1.7,7,1.7c2,0,4.1-0.4,5.9-1.2c1.7-0.8,3.2-1.9,4.4-3.3c1.2-1.4,2-3,2.4-4.8h-8.8c-0.7,1.7-2.4,2.7-4.3,2.6 c-1.3,0-2.5-0.4-3.5-1.3c-1-1-1.6-2.4-1.6-3.8h18.6C262.6,74.9,262.7,74.1,262.7,73.3L262.7,73.3L262.7,73.3z M244,71.1 c0.1-1.3,0.8-2.5,1.8-3.4c1-0.8,2.2-1.2,3.5-1.2c1.3,0,2.6,0.4,3.6,1.3c1,0.8,1.5,2.1,1.4,3.4H244L244,71.1z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg04);
export default __webpack_public_path__ + "static/media/04.c77162bbd35647228e21956ebffaf0f3.svg";
export { ForwardRef as ReactComponent };